// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, MessagePayload } from "firebase/messaging";
import apiClient from "./api/apiClient";

// 1. Firebase Configuration
const firebaseConfig = {
    apiKey: "AIzaSyDZG6EQnXji7dWehLeHm-WbISV4WPTnMpY",
    authDomain: "learnex-35fb9.firebaseapp.com",
    databaseURL: "https://learnex-35fb9-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "learnex-35fb9",
    storageBucket: "learnex-35fb9.firebasestorage.app",
    messagingSenderId: "486653453841",
    appId: "1:486653453841:web:55c18b1206e5c5919933b0",
    measurementId: "G-9QCDKKLL89"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Keep VAPID key in env so different deployments can use the correct web push config.
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY ?? "";

const TENANT_ID = process.env.REACT_APP_TENANT_ID ?? "1";

function isLikelyValidVapidKey(key: string): boolean {
    // Firebase Web Push public key is URL-safe base64-ish text, typically long.
    return /^[A-Za-z0-9\-_]+$/.test(key) && key.length >= 80;
}

/**
 * Send the FCM token to the backend server.
 */
const sendTokenToBackend = async (token: string) => {
    try {
        // Uses apiClient to automatically attach the Bearer token from sessionStorage
        await apiClient.post("/auth/notification",
            { notificationId: token },
            { params: { tenantId: TENANT_ID } }
        );
        console.log("FCM Token sent to server successfully.");
    } catch (error) {
        // It's common to fail if the user isn't logged in yet; we silently ignore or log debug
        console.debug("Failed to send FCM token to server (user might not be logged in):", error);
    }
};

/**
 * Request notification permission and retrieve the FCM token.
 */
export const requestForToken = async () => {
    try {
        if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
            return;
        }

        if (!VAPID_KEY || VAPID_KEY.includes("YOUR_ACTUAL_LONG_VAPID_KEY_HERE") || !isLikelyValidVapidKey(VAPID_KEY)) {
            console.warn("Skipping FCM token retrieval: invalid REACT_APP_FIREBASE_VAPID_KEY.");
            return;
        }

        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
            if (currentToken) {
                console.log("FCM Token Generated:", currentToken);
                await sendTokenToBackend(currentToken);
            } else {
                console.log("No registration token available. Request permission to generate one.");
            }
        } else {
            console.log("Notification permission denied.");
        }
    } catch (err) {
        // Push config issues should not break admin flows like saving questions.
        console.debug("FCM token retrieval skipped:", err);
    }
};

/**
 * Listener for foreground messages (App is open).
 */
export const onMessageListener = (): Promise<MessagePayload> =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
